import React, { useState } from "react";
import { X, Plus } from "lucide-react";
import { Input } from "src/components/ui/input";
import { Button } from "src/components/ui/button";

// Chip-style amenities editor: type + Enter (or the Add button) to add, click ×
// to remove. A few common suggestions speed up data entry.
const SUGGESTIONS = [
  "Clubhouse", "Swimming Pool", "Gymnasium", "Covered Parking", "24x7 Security",
  "Power Backup", "Lift", "Garden", "Kids' Play Area", "Modular Kitchen",
];

export function AmenitiesEditor({ value = [], onChange }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const item = raw.trim();
    if (!item) return;
    if (value.some((v) => v.toLowerCase() === item.toLowerCase())) return;
    onChange([...value, item]);
    setDraft("");
  };
  const remove = (item) => onChange(value.filter((v) => v !== item));

  const unusedSuggestions = SUGGESTIONS.filter(
    (s) => !value.some((v) => v.toLowerCase() === s.toLowerCase()),
  );

  return (
    <div className="space-y-2.5">
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {value.map((item) => (
            <span
              key={item}
              className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 py-1 pl-3 pr-1.5 text-[13px] text-slate-700"
            >
              {item}
              <button
                type="button"
                onClick={() => remove(item)}
                className="rounded-full p-0.5 text-slate-400 hover:bg-slate-200 hover:text-slate-600"
                aria-label={`Remove ${item}`}
              >
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center gap-2">
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add(draft);
            }
          }}
          placeholder="Add an amenity and press Enter"
        />
        <Button type="button" variant="outline" size="sm" className="gap-1" onClick={() => add(draft)}>
          <Plus className="h-3.5 w-3.5" /> Add
        </Button>
      </div>

      {unusedSuggestions.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {unusedSuggestions.slice(0, 8).map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => add(s)}
              className="rounded-full border border-dashed border-slate-300 px-2.5 py-0.5 text-[12px] text-slate-500 hover:border-slate-400 hover:text-slate-700"
            >
              + {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
